module.exports = __webpack_public_path__ + "static/media/education.2c84cc67.jpg";